<template>
  <el-dialog custom-class="max-dialog" title="隐形批次号" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-table
        :data="scancodes"
        size="mini"
        stripe
        border :height="tableHeight(90)"
        style="width: 100%;">
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="seedcode" v-if="false"
          label="编码"
          align="left" width="80" :show-overflow-tooltip="true"
          header-align="center">
          <template slot-scope="scope">
            {{scope.row.seedcode}}
          </template>
        </el-table-column>
        <el-table-column
          prop="seedname"
          label="名称"
          align="left"  width="200" :show-overflow-tooltip="true"
          header-align="center">
        </el-table-column>
        <el-table-column
          label="球镜"
          align="left" width="80"
          header-align="center">
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize,'Y')}}
          </template>
        </el-table-column>
        <el-table-column
          label="柱镜"
          align="left" width="80"
          header-align="center">
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize,'X')}}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalnumber"
          label="数量"
          align="center"
          width="50"
          header-align="center">
          <template slot-scope="scope">
            {{scope.row.totalnumber}}
          </template>
        </el-table-column>
        <el-table-column
          prop="batchno"
          label="批次号"
          align="left"
          width="300"
          header-align="center" v-if="issale">
          <template slot-scope="scope">
            <div v-if="!isshowqr">{{scope.row.batchno}}</div>
            <div v-else>
              <el-select v-else v-model="scope.row.batchno" style="width: 200px" v-for="certRow in certs" :key="certRow.seedcode"
                         v-if="certRow.seedcode==scope.row.seedcode" @change="selBatchNo(scope.row,certRow.cert)" filterable size="small">
                <el-option v-for="item in certRow.cert" v-if="item.packagesize==scope.row.packagesize" :key="item.unitguid"
                           :label="item.batchno"
                           :value="item.batchno">
                  <span style="float: left">{{ item.batchno }}</span>
                  <span style="float: right; color: dodgerblue; font-size: 13px">&nbsp;/ {{ item.totalnumber}}</span>
                  <span style="float: right; color: red; font-size: 13px" v-if="item.endtime&&new Date(item.endtime)<new Date()"><b>{{ item.endtime?item.endtime.split(' ')[0]:'' }}</b></span>
                  <span style="float: right; color: #8492a6; font-size: 13px" v-else>{{ item.endtime?item.endtime.split(' ')[0]:'' }}</span>
                </el-option>
              </el-select>
              <el-button icon="el-icon-bottom" style="width:60px" type="text" @click="copyItem(scope.row)" size="mini">复制</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="batchno"
          label="批次号"
          align="left"  v-if="!issale"
          width="250"
          header-align="center">
          <template slot-scope="scope">
            <div v-if="!isshowqr">{{scope.row.batchno}}</div>
            <div v-else>
            <el-input style="width:130px" size="small" v-model="scope.row.batchno" @blur="scope.row.batchno=scope.row.batchno.toUpperCase()"></el-input>
            <el-button icon="el-icon-bottom" style="width:60px" type="text" @click="copyItem(scope.row)" size="mini">复制</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="endtime"
          label="有效期"
          align="left"
          width="150"
          header-align="center">
          <template slot-scope="scope">
            <div v-if="!isshowqr||issale">{{scope.row.endtime?scope.row.endtime.split(' ')[0]:''}}</div>
            <el-date-picker v-else style="width:100%" size="small"
                            v-model="scope.row.endtime" :value-format="'yyyy-MM-dd'"
                            type="date">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="certno"
          label="证号"
          align="left"
          width="180"
          header-align="center">
          <template slot-scope="scope">
            <div v-if="!isshowqr||issale">{{scope.row.certno}}</div>
            <div v-else>
            <el-select  v-model="scope.row.certno" v-for="certRow in certs" :key="certRow.seedcode" v-if="certRow.seedcode==scope.row.seedcode" @change="selCertNo(scope.row,certRow.cert)" filterable size="small">
              <el-option v-for="item in certRow.cert" :key="item.unitguid"
                         :label="item.certno"
                         :value="item.certno">
              </el-option>
            </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="certorg"
          label="厂家"
          align="left"
          width="140" :show-overflow-tooltip="true"
          header-align="center">
          <template slot-scope="scope">
            {{scope.row.certorg}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveData" v-if="isshowqr" :loading="loading">保 存</el-button>
      <el-button type="warning" @click="importEdit" size="mini">导入</el-button>
      <a href="./static/file/隐形导入格式.xls">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
    </div>
  </el-dialog>
</template>

<script>
  import {getlistSimp} from '@/api/set/certmanage'
  import {listBarchno,listBarchnoSub,getDetail,replenishBatchno} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: "ScanCodeBatch",
    data() {
      return {
        isshowqr:false,
        loading:false,
        issale:false,
        buyerpserial:'',
        yinxinseedcode:[],
        scancodes: [],
        cangkucode:'',
        groupguid:'',
        bulu:false,
        existsmoreseed:false,
        certs:[],
        dialogFormVisible: false,
      }
    },
    methods: {
      getPackagesize(Packagesize,col) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        return ps[col];// + ' ， C：' + ps.X;
      },
      error(msg,id) {
        this.$message({
          message: msg,
          type: 'error'
        })
       // this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      importEdit(){
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      changeTime(times){
        if(!times) return '';
        var d=new Date(times);
        return d.getFullYear()+"-"+this.pad0(d.getMonth()+1)+"-"+this.pad0(d.getDate());
      },
      pad0(num){
        if(num<10) return '0'+num;
        return num;
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {

              for (var j in data) {
                var item = data[j]
                var Y = parseFloat(item['球镜']);
                var X = parseFloat(item['柱镜']);
                var num = parseInt(item['数量']);
                if (!num || num <= 0) num = 1;
                for (let i in this.scancodes) {
                  var row = this.scancodes[i];
                  if(row.batchno) continue;
                  if(row.packagesize) {
                    var ps = JSON.parse(row.packagesize);
                    if (Y == parseFloat(ps.Y) && X == parseFloat(ps.X) && num > 0 && (!this.existsmoreseed || item['商品编码'] == row.seedcode)) {
                      row.batchno = item['批次号'];
                      row.endtime = this.changeTime(item['有效期']);
                      if (item['证号'])
                        row.certno = item['证号'];
                      if (item['厂家'])
                        row.certorg = item['厂家'];
                      num = num - 1;
                    }
                  }else{
                    if (num > 0 && (!this.existsmoreseed || item['商品编码'] == row.seedcode)) {
                      row.batchno = item['批次号'];
                      row.endtime = this.changeTime(item['有效期']);
                      if (item['证号'])
                        row.certno = item['证号'];
                      if (item['厂家'])
                        row.certorg = item['厂家'];
                      num = num - 1;
                    }
                  }
                }
              }
              console.log(this.scancodes)
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      saveData() {
        this.loading = true
        //判断唯一码是否唯一
        if (this.scancodes.length > 0) {
          var scancodelist = this.scancodes;//
          for (var i = 0; i < scancodelist.length; i++) {
            if (scancodelist[i].batchno == '') {
              this.error('批次号必填！', scancodelist[i].id)
              this.loading = false;
              return
            }
            for (var j = i + 1; j < scancodelist.length; j++) {
              if (!scancodelist[j])
                break;
              if (scancodelist[i].batchno == scancodelist[j].batchno) {
                if (scancodelist[j].endtime == null || scancodelist[j].endtime == '') {
                  scancodelist[j].endtime = scancodelist[i].endtime;
                }
                if (scancodelist[j].certno == null || scancodelist[j].certno == '') {
                  scancodelist[j].certno = scancodelist[i].certno;
                }

                if (scancodelist[i].endtime != scancodelist[j].endtime
                  || scancodelist[i].certno != scancodelist[j].certno) {
                  this.loading = false;
                  this.error('相同批次号的有效期、证号应该一致！', scancodelist[i].id)
                  return
                }
              }
            }

            if (scancodelist[i].endtime == '') {
              this.loading = false;
              this.error('有效期必填！', scancodelist[i].id)
              return
            }
            if (scancodelist[i].certno == '') {
              this.loading = false;
              this.error('证号必填！', scancodelist[i].id)
              return
            }
          }
        }
        if (this.loading) {
          this.dialogFormVisible = false
          this.$emit("scancodeedit", this.scancodes)
        }
      },
      copyItem(item){
        for(let i in this.scancodes){
          if(this.scancodes[i].id>item.id) {
            this.scancodes[i].certorg = item.certorg;
            this.scancodes[i].batchno = item.batchno;
            this.scancodes[i].starttime = item.starttime;
            this.scancodes[i].endtime = item.endtime;
            this.scancodes[i].certno = item.certno;
          }
        }
      },
      selCertNo(item,certRow){
        for(let i in certRow){
          if(certRow[i].certno==item.certno) {
            item.certorg = certRow[i].certorg;
          }
        }
      },
      selBatchNo(item,certRow){
        for(let i in certRow){
          if(certRow[i].batchno==item.batchno&&certRow[i].packagesize==item.packagesize) {
            item.certorg = certRow[i].certorg;
            item.certno = certRow[i].certno;
            item.endtime = certRow[i].endtime;
          }
        }
      },
      show(controlData,scan,isshowqr,seedcodes) {
        this.loading = false;
        this.bulu=false;
        this.existsmoreseed=false;
        this.issale = controlData.issale;
        this.buyerpserial=controlData.buyerpserial?controlData.buyerpserial:'';
        if(this.buyerpserial)
          this.issale=false;//采购同时退货

        if(!this.issale) {//采购单
          if (controlData.billmap[0]['数量'] < 0) {
            this.issale = true;//退货单
          }
        }
        this.cangkucode=controlData.cangkucode;
        this.groupguid=controlData.groupguid;
        this.isshowqr = isshowqr;
        this.yinxinseedcode=seedcodes
        this.dialogFormVisible = true
        if (!isshowqr) {
          listBarchno({inordernum: controlData.erpserial,groupguid:this.groupguid}).then(response => {
            this.scancodes = response.data.obj
          });
          return;
        }
        this.initScancodes(controlData, scan, isshowqr);
      },
      initScancodes(controlData,scan) {
        var scancodes = JSON.parse(JSON.stringify(scan))
        if (scancodes.length > 0)
          return;

        var index = 0;
        var firstseedcode='';
        for (let i in controlData.billmap) {
          if (controlData.billmap[i]["产品名称"] == "合计")
            continue;
          // if (!(controlData.billmap[i]["packagesize"] && controlData.billmap[i]["packagesize"].indexOf('"X"') > -1))
          //   continue;
          var seedcode = controlData.billmap[i]["seedcode"];
          var exists=false;
          for(let j in this.yinxinseedcode){
            if(this.yinxinseedcode[j].seedcode==seedcode){
              exists=true;
              break;
            }
          }
          if(!exists)
            continue;

          var hasValue = false;
          for (let j = 0; j < this.certs.length; j++) {
            if (seedcode == this.certs[j].seedcode) {
              hasValue = true;
              break;
            }
          }
          if (!hasValue) {
            this.certs.push({seedcode: seedcode, cert: []})
          }
          if(firstseedcode=='') firstseedcode=seedcode;
          if(seedcode!=firstseedcode) this.existsmoreseed=true;//存在多个隐形商品

          var totalnumber=controlData.billmap[i]['数量'];
          var setnum=1;
          if(totalnumber<0) {
            setnum = -1;
            totalnumber = -totalnumber;
          }
          for (var j = 0; j <totalnumber; j++) {
            scancodes.push({
              "seedcode": seedcode,
              "seedname": controlData.billmap[i]["产品名称"],
              "cangkucode": controlData.cangkucode,
              "erpserial": "",
              "buyerpserial":this.buyerpserial,
              "packagesize": controlData.billmap[i]["packagesize"]?controlData.billmap[i]["packagesize"]:'',
              "totalnumber":setnum,
              "batchno": "",
              "certno": '',//this.certs.length > 0 ? this.certs[0]["certno"] : "",
              "certorg": '',// this.certs.length > 0 ? this.certs[0]["certorg"] : "",
              "starttime": "",
              "endtime": "",
              "id": index
            });
            index = index + 1;
          }
        }
        this.scancodes = scancodes;
        for (let j = 0; j < this.certs.length; j++) {
          if (this.issale) {
            this.getBatchNo(this.certs[j])
          } else {
            this.getCertNo(this.certs[j]);
          }
        }
      },
      getBatchNo(item) {//库存的有效商品
        listBarchnoSub({
          allnumber: '1',
          cangkucode:this.cangkucode,
          seedcode: item.seedcode,
        }).then(response => {
          item.cert = response.data.obj;
        }).catch((error) => {
          console.log(error)
        });
      },
      getCertNo(item) {//后台配置的证书：采购和盘点时使用
        getlistSimp({
          certtype: '1',
          seedcode: item.seedcode,
        }).then(response => {
          item.cert = response.data.obj;
          if (item.cert.length > 0) {
            for (let i in this.scancodes) {
              if (this.scancodes[i].seedcode == item.seedcode) {
                this.scancodes[i].certno=item.cert[0].certno;
                this.scancodes[i].certorg=item.cert[0].certorg;
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      //回车跳入下一行  上下方向键
      validateCounts(row, index, e) {
        setTimeout(() => {
          var keyCode = e.keyCode || e.which || e.charCode;
          if (keyCode == 40 || keyCode === 13) {//回车，下方向键
              this.$refs[row.id].blur()
              if (this.scancodes.length - 1 === index) {
                index = -1
              }
              this.$refs[Object.keys(this.$refs)[index + 1]].focus();
          } else if (keyCode == 38) {//上方向键
            this.$refs[row.id].blur()
            if (index === 0) {
              index = this.scancodes.length
            }
            this.$refs[Object.keys(this.$refs)[index - 1]].focus();
          }
        }, 100)
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.scancodes[index].id = index
        return index + 1;
      }
    },
    mounted() {
    }
    ,
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScanCodeBatch.vue